import BoatSharing from 'components/about/boatSharing';
import Hero from 'components/about/hero';
import SocialProof from 'components/about/socialProof';
import DefaultLayout from 'components/layouts/DefaultLayout';
import getConfig from 'next/config';
import Head from 'next/head';

const { RAILS_URL } = getConfig().publicRuntimeConfig;

const AboutPage = () => {
  const canonicalTag = `${RAILS_URL}/about`;

  return (
    <DefaultLayout white isAbout noFollow={false}>
      <Head>
        <title>About Boatsetter | Peer-to-Peer Boat Rental Marketplace</title>
        <meta
          name="description"
          content="Boatsetter is the world's leading peer-to-peer boat rental marketplace. Connecting boat owners and renters since 2013, with 50,000+ boats across 700+ locations worldwide."
        />
        <link rel="canonical" href={canonicalTag} key="canonical" />
      </Head>
      <Hero />
      <SocialProof />
      <BoatSharing />
    </DefaultLayout>
  );
};

export default AboutPage;
